// Centralised image URLs — every image below is provided by the restaurant owner.
// No stock photography is used anywhere on the site.

export const LOGO =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_dfb03dda-ca55-4e8f-88f2-8942803ea312/artifacts/hwef7d1b_logolamatze-351w.webp";

// --- Restaurant ---
export const STOREFRONT =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_dfb03dda-ca55-4e8f-88f2-8942803ea312/artifacts/eiuvpia3_WhatsApp%20Image%202026-07-19%20at%2023.22.08.jpeg";

export const INTERIOR =
  "https://customer-assets-jt897jd0.emergentagent.net/job_matze-suisse/artifacts/7crgsfat_WhatsApp%20Image%202026-07-20%20at%2000.33.45.jpeg";

// --- Dishes (existing) ---
export const MEAT_GRATIN =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_dfb03dda-ca55-4e8f-88f2-8942803ea312/artifacts/ktv209zz_WhatsApp%20Image%202026-07-20%20at%2000.13.56.jpeg";

export const LEMON_FISH =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_dfb03dda-ca55-4e8f-88f2-8942803ea312/artifacts/14eer4jg_WhatsApp%20Image%202026-07-20%20at%2000.58.48.jpeg";

export const LAMB_CHOPS =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_dfb03dda-ca55-4e8f-88f2-8942803ea312/artifacts/mh1eyoyc_WhatsApp%20Image%202026-07-20%20at%2000.59.01.jpeg";

// --- Dishes (new batch) ---
export const SALADE_MAISON =
  "https://customer-assets-jt897jd0.emergentagent.net/job_matze-suisse/artifacts/tb8weuam_WhatsApp%20Image%202026-07-20%20at%2000.11.27.jpeg";

export const OSSO_BUCO =
  "https://customer-assets-jt897jd0.emergentagent.net/job_matze-suisse/artifacts/isyc21xk_WhatsApp%20Image%202026-07-20%20at%2000.19.56.jpeg";

export const FOIE_GRAS =
  "https://customer-assets-jt897jd0.emergentagent.net/job_matze-suisse/artifacts/7i0xmyr8_WhatsApp%20Image%202026-07-20%20at%2000.20.11.jpeg";

export const CARPACCIO =
  "https://customer-assets-jt897jd0.emergentagent.net/job_matze-suisse/artifacts/5q9e5ycl_WhatsApp%20Image%202026-07-20%20at%2000.24.49%20%281%29.jpeg";

// --- Gallery collection ---
export const GALLERY = [
  { src: STOREFRONT,    label: "La devanture, rue Chaponnière" },
  { src: INTERIOR,      label: "La salle, ambiance chaleureuse" },
  { src: LAMB_CHOPS,    label: "Carré d'agneau, polenta crémeuse" },
  { src: OSSO_BUCO,     label: "Souris d'agneau, polenta & courgettes" },
  { src: MEAT_GRATIN,   label: "Souris d'agneau confite, gratin dauphinois" },
  { src: LEMON_FISH,    label: "Filet de perche façon Matze" },
  { src: SALADE_MAISON, label: "Salade maison, prosciutto & crevettes" },
  { src: CARPACCIO,     label: "Carpaccio de bœuf" },
  { src: FOIE_GRAS,     label: "Foie gras, salade de roquette" },
];

export const RESTAURANT = {
  name: "La Matze",
  tagline: "Restaurant · Pizzeria · Fondues · Charbonnade",
  address: "Rue Chaponnière 7, 1201 Genève",
  phone: "+41 22 732 79 61",
  phone_tel: "+41227327961",
  email: "restolamatze@gmail.com",
  hours: "Lundi – Samedi · 10h00 – 22h00 · Fermé le dimanche",
};

// --- WhatsApp booking ---
// Number: +41 76 425 49 35 (Swiss mobile). International, digits only.
export const WHATSAPP_NUMBER = "41764254935";
export const WHATSAPP_DISPLAY = "+41 76 425 49 35";
export const WHATSAPP_DEFAULT_MSG =
  "Bonjour, je souhaite réserver une table chez La Matze.";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_DEFAULT_MSG)}`;
